import { render, staticRenderFns } from "./LoadingApp.vue?vue&type=template&id=5fbfec92&scoped=true"
import script from "./LoadingApp.vue?vue&type=script&lang=js"
export * from "./LoadingApp.vue?vue&type=script&lang=js"
import style0 from "./LoadingApp.vue?vue&type=style&index=0&id=5fbfec92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbfec92",
  null
  
)

export default component.exports